import styled, { css } from 'styled-components';

import { Col } from '@zillow/zrs-comet';

const hpAccent = '#DBDBDB';

export const StyledCol = styled(Col).attrs({ useSpacingMixin: true })``;

export const StyledPhotoUpload = styled.div(({ theme }) => css`
    .property-image, &.property-image {
        margin-left: -${theme.ns().spacing.xs()};
        padding-left: ${theme.ns().spacing.sm()};
        margin-right: -${theme.ns().spacing.xs()};
        padding-right: ${theme.ns().spacing.sm()};
    }
    .sort-handle {
        display: none;
        ${theme.ns().media.lg(css`
            color: ${hpAccent};
            cursor: move;
            display: table-cell;
            font-size: 100px;
            line-height: 10px;
            padding-right: ${theme.ns().spacing.xl()};
            vertical-align: middle;
            user-select: none;
        `)}
    }
    .photo-table-display {
        width: 100%;
        ${theme.ns().media.lg(css`
            display: table-cell;
        `)}
    }
    &.on-drag {
        background-color: ${theme.ns().colors.white};
        border: 1px solid ${hpAccent};
    }
`);

export const PhotoUploadDropzoneContainer = styled.div`
    display: flex;
    flex-flow: column;

    /* override mui */
    .DropzoneContainer {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        min-height: 200px;
    }

    /* override */
    .IconItem {
        align-items: center;
        flex: 1 0 0;
    }
`;
